var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-block" },
    [
      _c(
        "div",
        { staticStyle: { "text-align": "right", "margin-bottom": "5px" } },
        [
          _c("span", [_vm._v(" Viendo documentos enviados a flujos ")]),
          _vm.rangeSelected.valor !== "personalizado"
            ? _c("span", [_vm._v(" " + _vm._s(_vm.rangeSelected.nombre) + " ")])
            : _vm._e(),
          _vm.rangeSelected.valor === "personalizado"
            ? _c(
                "span",
                [
                  _vm._v(" entre el "),
                  _c("datetime", {
                    attrs: {
                      "input-class": "input-date",
                      phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                      "value-zone": "local",
                      format: "yyyy-MM-dd",
                      "data-cy": "start-time"
                    },
                    model: {
                      value: _vm.rangeFrom,
                      callback: function($$v) {
                        _vm.rangeFrom = $$v
                      },
                      expression: "rangeFrom"
                    }
                  }),
                  _vm._v(" y el "),
                  _c("datetime", {
                    attrs: {
                      "input-class": "input-date",
                      phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                      "value-zone": "local",
                      format: "yyyy-MM-dd",
                      "data-cy": "end-time"
                    },
                    model: {
                      value: _vm.rangeUntil,
                      callback: function($$v) {
                        _vm.rangeUntil = $$v
                      },
                      expression: "rangeUntil"
                    }
                  }),
                  _c(
                    "span",
                    [
                      _c("vs-button", {
                        staticClass: "ml-3 d-inline",
                        attrs: {
                          radius: "",
                          color: "primary",
                          type: "border",
                          icon: "search",
                          size: "small"
                        },
                        on: {
                          click: function($event) {
                            return _vm.changeFilters(_vm.currentFilters)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "vs-dropdown",
            {
              staticStyle: { "margin-left": "15px" },
              attrs: { "vs-trigger-click": "" }
            },
            [
              _c(
                "a",
                { staticClass: "a-icon", attrs: { href: "#" } },
                [
                  _vm._v(" Cambiar "),
                  _c("vs-icon", { attrs: { icon: "expand_more" } })
                ],
                1
              ),
              _c(
                "vs-dropdown-menu",
                _vm._l(_vm.ranges, function(range) {
                  return _c(
                    "vs-dropdown-item",
                    {
                      key: range.valor,
                      staticStyle: { width: "200px" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.selectRange(range)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(range.nombre) + " ")]
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("filtros-letty", {
        attrs: {
          filtersView: _vm.filterView,
          users: _vm.usersCompany,
          groups: _vm.groupsCompany,
          documents: _vm.configuredDocuments,
          periodos: _vm.ranges,
          "has-query-filters": !!_vm.queryFilters,
          "clear-query-filters": _vm.clear
        },
        on: { "filtros-aplicados": _vm.changeFilters }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }